<template>
<div>

  <div class="box">
    <assessment-builder @created="setAssessor" v-if="!checkpoint.assessor.id"/>
    <div v-else>
      <div class="columns">
        <div class="column">
          <h4 class="title is-5 is-marginless">{{ assessor.type.name }}</h4>
          <p class="has-text-grey">{{ assessor.type.description }}</p>

          <p class="has-text-danger" v-if="assessor.type.standard_fed">
            This assessor receives it's secure setting value from the respective standards it is associated with.
          </p>
          <p class="has-text-danger" v-else>
            This assessor does not verify against a secure setting on a standard. It's finding is self evident.
          </p>
        </div>
        <div class="column is-narrow">
          <div class="buttons">
            <action-button @click="deleteAssessor">Delete</action-button>
          </div>
        </div>
      </div>

      <div>        
        <div class="columns">
          <div class="column">
            <p class="has-text-weight-bold has-text-primary">Associated Standards</p>
          </div>
        </div>

        <div v-for="section in checkpoint.sections" :key="section.id">
          <div class="columns">
            <div class="column">
              {{ section.standard.name }}
            </div>
            <div class="column is-narrow">
              <span v-if="assessor.type.standard_fed">
                <span>{{ section.setting.secure_setting }}</span>
                <span class="tag is-danger" v-if="!section.setting.secure_setting">
                  Missing required secure setting
                </span>
              </span>
              <span class="tag" v-else>
                Setting not required
              </span>
            </div>
            <div v-if="assessor.type.standard_fed" class="column is-narrow">
              <a @click="openSecureSettingEditor(section)">edit</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import AssessmentBuilder from '@/views/assessors/Builder'
import { editSecureSetting } from '@/modals'

export default {

  components: {
    AssessmentBuilder,
  },

  data: () => ({
    working: false,
  }),

  methods: {
    ...mapMutations('checkpoint', [
      'updateValue',
      'updateCwe',
      'setAssessor'
    ]),
    async deleteAssessor() {
      if(await this.$confirm({
        title: 'Delete Assesor',
        message: 'Are you sure you want to delete this assessor it will also delete all previous findings.'
      })) {
        this.$store.dispatch('assessor/deleteAssessor', this.assessor.id).then(() => {
          this.$store.commit('checkpoint/clearAssessor')
          this.$toast.success('Assessor Deleted')
        }).catch(error => {
          console.log(error)
        })
      }
    },
    openSecureSettingEditor(section) {
      editSecureSetting(section).then(reload => {
        if(reload) {
          this.$store.dispatch('checkpoint/loadCheckpoint', this.$route.params.checkpoint)
        }
      })
    }
  },

  computed: {
    ...mapGetters('checkpoint', [
      'checkpoint'
    ]),
    assessor() {
      return this.checkpoint.assessor
    }
  }

}
</script>
